<div class="modal-header">
  <h3 class="m-0">Attention: Transfer of keepership pending</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
  </button>
</div>

<div class="modal-body">
  <p>It appears you haven't completed the payment to finalise the transfer process.</p>
  <p>
    Without completing the payment, the transfer of keepership cannot be processed, your new pet will not be added to your account and will revert to the breeder’s account.
  </p>
  <p class="mb-0">To complete the transfer, please proceed to complete the payment now.</p>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary text-white btn-lg"
    (click)="completeTok()"
  >
    <img
      *appFeatureFlag="'isPawnVisibleInButton'"
      width="28"
      class="me-1"
      src="assets/images/identibase/whitepawlarge.png"
      alt="White paw"
    />
    Complete payment
  </button>
</div>
